import { ModalWrapper } from "src/utils/fw";
import { auditoriumCloseDate } from "../utils";

export default {
    background: "https://assets.swoogo.com/uploads/full/2938714-6511be4c28d27.png",
    name: "auditorium-hall",
    links: [
        {
            label: "Auditorium 1",
            height: "34.2%",
            href: new Date() < auditoriumCloseDate ? "/auditorium" : undefined,
            left: "3.2%",
            top: "37%",
            width: "13.6%",
            modal: new Date() < auditoriumCloseDate ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)", textAlign: "center"}}>
                <h1 style={{color: "white"}}>The Auditorium is now closed.</h1>
                <p style={{color: "white"}}>Please head over to our On-Demand Rooms to view session recordings, and browse through our ISF Exploration Zone and Exhibition Hall until Tuesday 14 November.</p>
            </ModalWrapper>,
            modalOverrides: {
                dismissHTML: "X",
                dismissStyle: {
                    color: "white",
                    "font-size": "20px"
                }
            }
	    },
        {
            label: "Auditorium 2",
            height: "34.2%",
            href: new Date() < auditoriumCloseDate ? "/auditorium-two" : undefined,
            left: "83.2%",
            top: "37%",
            width: "13.6%",
            modal: new Date() < auditoriumCloseDate ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)", textAlign: "center"}}>
            <h1 style={{color: "white"}}>The Auditorium is now closed.</h1>
            <p style={{color: "white"}}>Please head over to our On-Demand Rooms to view session recordings, and browse through our ISF Exploration Zone and Exhibition Hall until Tuesday 14 November.</p>
            </ModalWrapper>,
            modalOverrides: {
                dismissHTML: "X",
                dismissStyle: {
                    color: "white",
                    "font-size": "20px"
                }
            }
        },
    ]
}